import {create} from "zustand";
import type {User} from "../model/type";

interface AuthState {
    accessToken: string | null;
    refreshToken: string | null;
    setAccessToken: (token: string | null) => void;
    setRefreshToken: (token: string | null) => void;
    user?: User | null;
    setUser: (user: User | null) => void;
    logout: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
    accessToken: localStorage.getItem('accessToken') ?? null,
    refreshToken: localStorage.getItem('refreshToken') ?? null,
    setAccessToken: (accessToken) => {
        set({ accessToken });
        if (accessToken) {
            localStorage.setItem('accessToken', accessToken);
        } else {
            localStorage.removeItem('accessToken');
        }
    },
    setRefreshToken: (refreshToken) => {
        set({ refreshToken });
        if (refreshToken) {
            localStorage.setItem('refreshToken', refreshToken);
        } else {
            localStorage.removeItem('refreshToken');
        }
    },
    user: loadUserFromLocalStorage(),
    setUser: (user) => {
        set({ user });
        saveUserToLocalStorage(user);
    },
    logout: () => {
        set({ accessToken: null, refreshToken: null, user: null });
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('user');
    },
}));

function loadUserFromLocalStorage(): User | null {
    const userString = localStorage.getItem('user');
    return userString ? JSON.parse(userString) : null;
}

function saveUserToLocalStorage(user: User | null) {
    if (user) {
        localStorage.setItem('user', JSON.stringify(user));
    } else {
        localStorage.removeItem('user');
    }
}
